/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".hoverCardExample-compactCard{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%}.hoverCardExample-expandedCard{padding:16px 24px}.HoverCard-item:hover{text-decoration:underline;cursor:pointer}"}]);
/* tslint:enable */